import Preview from "containers/Pages/Preview/v2"

export default Preview